import { gql } from '@apollo/client';
import { gql as graphql } from '@api/gql';
import {
  ADDRESS_CORE_FRAGMENT,
  CYNERGY_ACCOUNT_CORE_FRAGMENT,
  DEMOGRAPHICS_CORE_FRAGMENT,
  USER_CORE_FRAGMENT
} from '@src/api/operations/fragments/fragments.gql';

export const GET_ALL_CYNERGY_USERS = graphql(/* GraphQL */`
  query GetAllCynergyUsers(
    $searchBy: SearchByArgs
    $pagination: PaginationArgs
    $sort: SortingArgs
    $options: QueryOptionsInputType
  ) {
    getAllCynergyUsers(
      searchBy: $searchBy
      pagination: $pagination
      sort: $sort
      options: $options
    ) {
      ...CynergyAccountCoreFragmentAlt
      demographics {
        ...DemographicsCoreFragmentAlt
      }
    }
  }
`);

export const GET_PAGINATED_CYNERGY_USERS = gql`
  ${CYNERGY_ACCOUNT_CORE_FRAGMENT}
  ${DEMOGRAPHICS_CORE_FRAGMENT}
  query GetPaginatedCynergyUsers($searchBy: SearchByArgs, $pagination: PaginationArgs, $options: QueryOptionsInputType) {
    getPaginatedCynergyUsers(searchBy: $searchBy, pagination: $pagination, options: $options) {
      count
      currentPage
      totalPages
      rows {
        ... on CynergyUsers {

          ...CynergyAccountCoreFragment
          demographics {
            ...DemographicsCoreFragment
          }
        }
      }
    }
  }
`;

export const USER_ACCOUNT = gql`
  ${USER_CORE_FRAGMENT}
  ${ADDRESS_CORE_FRAGMENT}
  ${CYNERGY_ACCOUNT_CORE_FRAGMENT}
  query GetUserAccount($searchBy: SearchByArgs, $userType: UserTypes) {
    getUserAccount(searchBy: $searchBy) {
      ... on Users {
        ...UserCoreFragment
        addresses {
          ...AddressCoreFragment
        }
        contacts {
          __typename
          contact_id
          first_name
          last_name
          nickname
          email
          phone
          authorized_access
          contact_type
          contact_relation_type
        }
        identity {
          ...CynergyAccountCoreFragment
        }
        actor(userType: $userType){
          ... on Patients{
            dependents {
              __typename
              patient_id
              primary_provider {
                practitioner_id
              }
            }
          }
        }
      }
    }
  }`;

export const GET_PATIENT = gql`
  ${USER_CORE_FRAGMENT}
  query GetPatient($searchBy: SearchByArgs) {
    getPatient(searchBy: $searchBy) {
      __typename
      patient_id
      user {
        __typename
        user_id
      }
      dependents {
        __typename
        patient_id
        user {
          __typename
          user_id
        }
        user {
          ...UserCoreFragment
        }
      }
      user {
        ...UserCoreFragment
      }

    }
  }
`;

export const GET_PATIENT_DETAILS = graphql(/* GraphQL */`
  query GetPatientDetails($searchBy: SearchByArgs) {
    getPatient(searchBy: $searchBy) {
      __typename
      patient_id
      user {
        __typename
        user_id
        demographics {
          ...DemographicsCoreFragmentAlt
        }
      }
      primary_provider {
        __typename
        practitioner_id
        demographics {
          ...DemographicsCoreFragmentAlt
        }
      }
    }
  }
`);

export const GET_PATIENT_DEMOGRAPHICS = graphql(/* GraphQL */`
  query GetPatientDemographics($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getPatient(searchBy: $searchBy, options: $options) {
      __typename
      patient_id
      user {
        __typename
        user_id
        demographics {
          ...DemographicsCoreFragmentAlt
        }
      }
    }
  }
`);

/**
 * Patient name/DOB + addresses — used to default an insurance coverage's
 * subscriber to the patient (relationship "Self", with the patient's default
 * address) when the subscriber section is left blank.
 */
export const GET_PATIENT_SUBSCRIBER = graphql(/* GraphQL */`
  query GetPatientSubscriber($searchBy: SearchByArgs) {
    getPatient(searchBy: $searchBy) {
      __typename
      patient_id
      user {
        __typename
        user_id
        demographics {
          __typename
          first_name
          last_name
          dob
        }
        addresses {
          __typename
          address_id
          address_line_1
          address_line_2
          city
          state
          zip
          is_default
        }
      }
    }
  }
`);

